module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Media/Add-music-b7c46955cd92b428f745ee4a94d02643.svg";